import { useNavigate } from 'react-router-dom'

import { RoutingPaths } from 'app/routes/routes'

import { RESULT_PAYMENT } from 'shared/api/check-payment'

import { KyrgyzstanError } from './components/kyrgyzstan-error'
import { KyrgyzstanPending } from './components/kyrgyzstan-pending'
import { KyrgyzstanSuccess } from './components/kyrgyzstan-success'

type Props = {
  status: RESULT_PAYMENT
}

export const KyrgyzstanPayment = ({ status }: Props) => {
  const navigate = useNavigate()

  const onClick = () => {
    navigate(RoutingPaths.kyrgyzstan.path())
  }

  const goToHome = () => {
    navigate(RoutingPaths.kyrgyzstan.path())
  }

  if (status === RESULT_PAYMENT.CANCELLED) {
    return <KyrgyzstanError onClick={onClick} />
  }

  if (
    status === RESULT_PAYMENT.IN_PROGRESS ||
    status === RESULT_PAYMENT.CREATED ||
    status === RESULT_PAYMENT.LOADING
  ) {
    return <KyrgyzstanPending onClick={onClick} />
  }
  return <KyrgyzstanSuccess onClick={goToHome} />
}
